import React from "react";

export type WaveTopBottomLoadingProps = {
  size?: number;         // px, default 64
  color?: string;        // CSS color, default #3db5e6
  speedMs?: number;      // default 1000
  className?: string;
  style?: React.CSSProperties;
};

export const WaveTopBottomLoading: React.FC<WaveTopBottomLoadingProps> = ({
  size = 64,
  color = "#3db5e6",
  speedMs = 1000,
  className,
  style
}) => {
  const cssVars: React.CSSProperties = {
    "--wtb-size": `${size}px`,
    "--wtb-color": color,
    "--wtb-speed": `${speedMs}ms`,
  } as React.CSSProperties;

  return (
    <span className={`wtb ${className ?? ""}`} style={{ ...cssVars, ...style }}>
      <span className="wtb__bar" />
      <span className="wtb__bar" />
      <span className="wtb__bar" />
      <span className="wtb__bar" />
      <span className="wtb__bar" />
    </span>
  );
};
